const en = {
    "global.turnOffMicrophone": "Turn off microphone",
    "global.turnOnMicrophone": "Turn on microphone",
    "global.turnOffCamera": "Turn off camera",
    "global.turnOnCamera": "Turn on camera",
    "global.settings": "Settings",
    "global.documentation": "Documentation",
    "global.you": "You",
    "global.flip": "Flip",
    "global.roomDetails": "Room details",
    "global.copied": "Copied",
    "global.roomMembers": "Room members",
    "global.search": "Search",
    "global.noSearchResults": "No search results",
    "global.roomMessages": "Room messages",
    "global.send": "Send a message to everyone",
    "global.leaveDialogTitle": "Leave the room",
    "global.leaveDialogDesc": "Are you sure to leave the room?",
    "global.confirm": "Confirm",
    "global.cancel": "Cancel",
    "global.leftRoom": "You have left the room.",
    "global.rejoin": "Rejoin",
    "global.return": "Return to home screen",
    "global.joining": "Joining Room",
    "global.network": "There's something wrong with your network. Trying to reconnect...",
    "global.networkMobile": "Trying to reconnect...",
    "global.mute": "Mute",
    "global.stop": "Stop",
    "global.enter": "enter",
    "global.quit": "quit",
    "global.room": " the room",
    "global.agree": "Agree",
    "global.disagree": "Disagree",
    "global.loading": "Loading...",
    "global.notice": "Notice",
    "global.loginRoomFailed": "Login room Failed",
    "global.equipment": "Equipment authorization",
    "global.equipmentDesc": "We can't detect your devices. Please check your devices and allow us access your devices in your browser's address bar. Then reload this page and try again.",
    "global.micPermission": "In the video call scenario, please grant microphone permissions before operating the device.",
    "global.cameraPermission": "In the video call scenario, please grant camera permissions before operating the device.",
    "global.browserNotSupportSharing": "Your browser does not support screen sharing.",
    "global.shareAuthority": "Grant access to share your screen",
    "global.shareAuthorityDesc": "Your system does not have access to share a screen from the browser. Please grant access to share your screen on your system settings.",
    "global.tooFrequent": "Operation too frequent, failed to load the whiteboard.",
    "global.joinRoomFailedDesc": "Failed to join the room, the number of people in the room has reached the maximum.(2 people)",
    "global.joinRoomFailedNetwork": "There's something wrong with your network. Please check it and try again.",
    "global.joinRoomFailedToken": "Failed to join the room, token authentication error.",
    "global.joinRoomFailedRepeat": "You are on a call in another room, please leave that room first.",
    "global.joinRoomFailed": "Failed to join the room, please try again.（error code: {code}）",
    "global.inviteMembers": "Invite members",
    "global.invitees": "Invitees",
    "global.checkRTC": "This device does not support RTC, please try another device",

    'browserCheck.join': "Join",
    "browserCheck.placeholder": "Your name",
    "browserCheck.shareTitle": "Share the link",
    "browserCheck.cameraDesc": "Camera is off",
    "browserCheck.cameraStart": "Camera is starting…",

    "room.microphoneStatus": "The microphone is ",
    "room.on": "on",
    "room.off": "off",
    "room.cameraStatus": "The camera is ",
    "room.presentingDesc": "You're presenting to everyone",
    "room.stopPresenting": "Stop Presenting",
    "room.presentingMirrorTip": " To avoid an infinity mirror, we suggest you not to share your entire screen or browser window.",
    "room.ignore": "Ignore",
    "room.live": "Go Live",
    "room.stopLive": "Stop broadcast",
    "room.living": "Start stream...",
    "room.stopLiveDesc": "Are you sure to stop broadcasting?",
    "room.turnOffMicToast": "Turned off the microphone successfully.",
    "room.turnOffCameraToast": "Turned off the camera successfully.",
    "room.sendInvitationSuccessToast": "Sent the invitation successfully.",
    "room.sendInvitationFailToast": "Failed to send the invitation, please try again.",
    "room.sendInvitation": "Invitation has been sent.",
    "room.copyToast": "Copy successfully",
    "room.noOneStreaming": "No one has turned on the camera or microphone yet.",
    "room.chageLayout": "Change layout",
    "room.fullScreen": "Full screen",
    "room.exitFullScreen": "Exit full screen",
    "room.thickness": "Thickness",
    "room.color": "Color",
    "room.font": "Font",
    "room.shape": "Shape",
    "room.whiteboard": "Whiteboard",
    "room.remove": "Remove participant",
    "room.removeDesc": "Are you sure to remove {user} ?",
    "room.removePin": "Remove Pin",
    "room.autoLayout": "Auto",
    "room.gridLayout": "Grid",
    "room.sidebarLayout": "Sidebar",
    "room.liveNotStarted": "The Live has not started yet",
    "room.invite": "Invite to connect",
    "room.endConnection": "End the connection",
    "room.endConnectionDesc": "Are you sure to end the connection with {user}?",
    "room.invitationDialogTitle": "Invitation",
    "room.invitationDialogDesc": "The host invites you to have a connection.",
    "room.appliedConnectionToast": "You've applied for connection, please wait for the host's confirmation.",
    "room.hostLeftToast": "The host has left the room.",
    "room.appliedFailToast": "Failed to send application, please try again.",
    "room.disagreedInvitationToast": "{user} disagreed with the invitation.",
    "room.InvitationSent": "Invitation has been sent.",
    "room.turnedCameraOff": "{user} has turned your camera off",
    "room.turnedMicOff": "{user} has turned your microphone off",
    "room.requestingConnectionToast": "{user} is requesting a connection with you.",
    "room.rejectedRequestToast": "The host has rejected your request.",
    "room.occupiedToast": "The audio and video equipment is being occupied by another application.",
    "room.otherScreenPresentingToast": "{user}  is presenting now. You cannot share your screen.",
    "room.otherWhiteboardPresentingToast": "{user} is presenting now. You cannot share your whiteboard.",
    "room.presenting": "{user} is presenting the screen",
    "room.presentingFailed": "Failed to present your screen. error code: {code}",
    "room.requestExpired": "The request for connecting has expired.",
    "room.browserNotSupport": "Your current browser does not support the display of multiple video screens during the live streaming.",
    "room.serviceNotAvailable": "The service is not available, please contact the live streaming service provider to resolve.",
    "room.resumePlayTips": 'Media play failed. Click the "Resume"to resume.',
    "room.resumePlay": "Resume",
    "room.banSending": "Ban sending messages",
    "room.cancelBanSending": "Cancel the message ban",

    "mobileRoom.member": "Member",
    "mobileRoom.chat": "Chat",
    "mobileRoom.whiteboard": "Whiteboard",
    "mobileRoom.layout": "Layout",
    "mobileRoom.presenting": "{user} is presenting.",
    "mobileRoom.systemNotSupport": "Your current mobile system does not support the display of multiple video screens during the live streaming.",
    "mobileRoom.browserNotSupport": "The current browser does not support the display of multiple video screens, we suggest you change your browser.",
    "mobileRoom.connect": "Connect",

    "settings.audio": "Audio",
    "settings.video": "Video",
    "settings.microphone": "Microphone",
    "settings.speakers": "Speakers",
    "settings.camera": "Camera",
    "settings.preview": "Preview",
    "settings.resolution": "Send resolution",
    "settings.test": "Test",
    "settings.showVideo": "Show non-video participant",

    "call.calling": "Calling…",
    "call.endCall": "End call",
    "call.cancelToast": "The call has been canceled.",
    "call.incoming": "Incoming call...",
    "call.decline": "Decline",
    "call.accept": "Accept",
    "call.cancelled": "Cancelled invitation",
    "call.incomingVoice": "Incoming {group}voice call...",
    "call.incomingVideo": "Incoming {group}video call...",
    "call.cancelCall": "Cancel call",

}
export default en;